export const TOTAL_NEWS_ITEMS = 500;
export const INCREMENT = 20;
